export default function ({ $auth, store }) {
  if ($auth.loggedIn) {
    store.dispatch(`login`)
  }
}
